import { Routes } from '@angular/router';
import { FlamingoAuthGuard } from '../@flamingo/service/flamingo-auth.guard';
import { UserType } from './core/model/user.model';

export const routes: Routes = [
  {
    path: 'auth',
    loadComponent: () => import('./children/authentication/children/login/login.component').then(m => m.LoginComponent),
    data: {
      type: UserType.debtor,
    },
  },
  {
    path: 'auth/set-password',
    loadComponent: () => import('./children/authentication/children/set-password/set-password.component').then(m => m.SetPasswordComponent),
  },
  {
    path: 'register/invitation/:token',
    loadComponent: () => import('./component/registration/registration.component').then(m => m.RegistrationComponent),
  },
  {
    path: 'register',
    loadComponent: () => import('./component/registration/registration.component').then(m => m.RegistrationComponent),
  },
  {
    path: '',
    canActivate: [FlamingoAuthGuard],
    loadComponent: () => import('./children/main/main.component').then(m => m.MainComponent),
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./children/main/children/debtor/children/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'profile',
        loadComponent: () => import('./children/main/children/debtor/children/profile-debtor/profile-debtor.component').then(m => m.ProfileDebtorComponent),
      },
      {
        path: 'documents',
        loadComponent: () => import('./component/documents/documents.component').then(m => m.DocumentsComponent),
      },
      {
        path: 'advances',
        loadComponent: () => import('./component/advances/advances.component').then(m => m.AdvancesComponent),
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'auth',
  }
];

